"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccountValidation = useAccountValidation;
var react_1 = require("react");
var client_1 = require("../features/apis/client");
var client_2 = require("../features/slices/client");
var hooks_1 = require("../store/hooks");
var client_storage_1 = require("../utils/client-storage");
var roles_1 = require("../utils/roles");
var ACTIVE_USER_STATUS = "ACTIVE";
function useAccountValidation() {
    var _a;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var token = (0, hooks_1.useAppSelector)(function (state) { return state.user.token; });
    var authUser = (0, hooks_1.useAppSelector)(function (state) { return state.user.user; });
    var activeClient = (0, hooks_1.useAppSelector)(function (state) { return state.client.client; });
    var isSystemAdmin = (0, roles_1.isSystemAdministratorRole)(authUser);
    var isAccountActive = (authUser === null || authUser === void 0 ? void 0 : authUser.status) === ACTIVE_USER_STATUS;
    var shouldLookupClient = !!token && !!(authUser === null || authUser === void 0 ? void 0 : authUser.client) && !activeClient && isAccountActive;
    var _b = (0, client_1.useGetMyClientQuery)((_a = authUser === null || authUser === void 0 ? void 0 : authUser._uid) !== null && _a !== void 0 ? _a : "", { skip: !shouldLookupClient }), data = _b.data, isFetching = _b.isFetching, isError = _b.isError, refetchClient = _b.refetch;
    var clientResolved = !!(data === null || data === void 0 ? void 0 : data.success) && !!data.content;
    (0, react_1.useEffect)(function () {
        if (!clientResolved || !(data === null || data === void 0 ? void 0 : data.content))
            return;
        dispatch((0, client_2.setClient)(data.content));
        (0, client_storage_1.saveClientSession)(data.content);
    }, [clientResolved, data, dispatch]);
    var status = (0, react_1.useMemo)(function () {
        if (!token)
            return "checking";
        if (!authUser)
            return "no-profile";
        if (activeClient)
            return "ready";
        if (!isAccountActive)
            return "suspended";
        if (authUser.client) {
            if ((!data && !isError) || isFetching)
                return "checking";
            if (clientResolved)
                return "checking"; // the effect above will populate activeClient shortly
            return "client-error";
        }
        return isSystemAdmin ? "select-client" : "no-client";
    }, [token, authUser, activeClient, isAccountActive, data, isError, isFetching, clientResolved, isSystemAdmin]);
    var retryClientLookup = function () {
        void refetchClient();
    };
    return { status: status, retryClientLookup: retryClientLookup };
}
